import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as ticketActions from './../../../../../actions/ticketAction';
import * as userActions from './../../../../../actions/userAction';
import MyTickets from './MyTickets';

const mapStateToProps = state => {
    return {
        ticketState: state.ticketReducer,
        userState: state.userReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMyTickets: (params) => dispatch(ticketActions.getMyTicketList(params)),

        getMyTicketDetail: (id) => dispatch(ticketActions.getMyTicketDetail(id)),
        setMyTicketDetail: (ticket) => dispatch(ticketActions.setMyTicketDetail(ticket)),
        updateMyTicket: (ticket) => dispatch(ticketActions.updateMyTicket(ticket)),
        
        getCSUsers: (params) => dispatch(userActions.getCSUserAction(params)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MyTickets));
